import axios from "axios";

const API = process.env.REACT_APP_JOB_BOARD_API_URL;

export const getKPIs = (token) =>
  axios.get(`${API}/admin/analytics/kpis`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getActivity = (token) =>
  axios.get(`${API}/admin/analytics/activity`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getUserGrowth = (token) =>
  axios.get(`${API}/admin/analytics/user-growth`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getJobCategories = (token) =>
  axios.get(`${API}/admin/analytics/job-categories`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getTopPerformers = (token) =>
  axios.get(`${API}/admin/analytics/top-performers`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getRecentActivity = (token) =>
  axios.get(`${API}/admin/analytics/recent-activity`, {
    headers: { Authorization: `Bearer ${token}` }
  });
